import React, { useEffect } from 'react';
import { useTemplateOrCalculation } from '../../../hooks/useTemplateOrCalculation';
import { useGetCalculationQuery } from '../apiCalculationDetail';
import { setSubpage } from '../../../routes/routerSlice';
import { CalculationDetailSubpages } from '../../Calculations/calculationsLib';
import LoadingIndicator from '../../../components/global/LoadingIndicator/LoadingIndicator';
import { CalculationType } from '@ydistri/api-sdk';
import { Helmet } from 'react-helmet-async';
import SectionStorePickingResults from './components/SectionStorePickingResults';
import { MainContent, MainContentWrapper, Title } from '@ydistri/ds';
import { useAppDispatch } from '../../../store';

/**
 * Main component for this section. Displays a header and a table for each source store.
 * Header contains overall calculation's picking status and a set of values/totals
 * This part follows the design of CalculationEvaluation component.
 */
const CalculationPickingResults: React.FC = () => {
  const dispatch = useAppDispatch();
  const templateOrCalculation = useTemplateOrCalculation();
  const { data: calculationData, isFetching } = useGetCalculationQuery(templateOrCalculation.id);

  useEffect(() => {
    dispatch(setSubpage(CalculationDetailSubpages.PICKING_RESULTS));
  }, [dispatch]);

  if (isFetching) return <LoadingIndicator />;
  if (!(calculationData?.type === CalculationType.Production && calculationData.isPap))
    return <Title>Calculation is not set for picking, picking results are not available.</Title>;

  return (
    <>
      <Helmet title={`Calculation ${templateOrCalculation.id} - Picking`} />
      <MainContentWrapper $flexDirection="column">
        <MainContent>
          <SectionStorePickingResults />
        </MainContent>
      </MainContentWrapper>
    </>
  );
};

export default CalculationPickingResults;
